export const cookieName = "myteamPortal";
export const reFreshTokenName = "reFreshToken";

export const mgTeam = {
  id: "7cf960ac-2bc8-48f6-8fd0-54ff4ddd8e9a",
  name: "Management Team",
};
export const seniorTeam = {
  id: "aaa968b9-1391-40ba-a5df-a3370870e262",
  name: "Senior Team",
};
export const l6Bunnings = {
  id: "b313e915-7497-4b2a-8e73-b9fa613ae6dc",
  name: "Level 6 - Bunnings",
};
export const l6Scaffolding = {
  id: "8616c88c-9ce5-4ba7-adb3-99e5adb50c6d",
  name: "Level 6 - RB Scaffolding",
};
export const l7SupportTeam = {
  id: "98fad217-1e79-4575-a0ec-34e2a96777b1",
  name: "Level 7 - Support Team",
};
export const l7SydneyFrame = {
  id: "33ac621b-bd4c-4f81-a91d-ac4281ae0e45",
  name: "Level 7 - Sydney Frame and Truss",
};
export const l7LeaderTeam = {
  id: "584bab98-2bc4-4aeb-bd1a-b206276132aa",
  name: "Level 7 - Leader Team",
};
export const l7Coastline = {
  id: "86a8d189-b4fb-4275-9f89-96812f211ca2",
  name: "Level 7 - Coastline",
};
export const l7CreativeHome = {
  id: "89a73700-847e-4e9d-9fe4-5c79ca876e2f",
  name: "Level 7 - Creative Home",
};
export const l7Brock = {
  id: "a2af6fea-ffa7-4ba5-9dee-62e3b7efab01",
  name: "Level 7 - Brock",
};
export const l7NorthProject = {
  id: "a3d5298d-05a1-4667-8c01-212913e018c3",
  name: "Level 7 - North Project",
};
export const l7BulkGroup = {
  id: "ce800f8d-f404-4d2e-9240-cf1b8978c93f",
  name: "Level 7 - Bulk Group",
};
export const l7Tradesmart = {
  id: "f58cbff5-5c18-4734-92de-80cfbe888839",
  name: "Level 7 - Tradesmart",
};
export const l7GJGardner = {
  id: "f7e7fd39-7688-4e1e-bebb-c71972f16a77",
  name: "Level 7 - GJ Gardner",
};
export const l7US = {
  id: "4729af37-b945-4e0f-849a-eac37f946af3",
  name: "Level 7 - US",
};
export const l8Tilling = {
  id: "b3c88514-62a5-4e37-9e9c-cd0f995f17f7",
  name: "Level 8 - Tilling",
};
export const l8Admin = {
  id: "5ba31ee9-d736-4c36-bd3c-69266800ed28",
  name: "Level 8 - Admin",
};
export const l9 = {
  id: "37bc7459-5671-4eb6-8339-a69bb339efbb",
  name: "Level 9",
};

export const adminCat = {
  id: "c2a1912f-e0d9-4e6c-a7d5-09720720e61d",
  name: "Admin",
};

export const manufacturingCat = {
  id: "113cff36-ed49-41c2-9eea-e411498ee7e3",
  name: "Manufacturing",
};

export const merchantCat = {
  id: "7e2ca215-6fcc-4cd9-a24e-1123328840b1",
  name: "Merchant",
};

export const builderCat = {
  id: "c0dc275f-62da-4a6a-8f58-a3572a0d3569",
  name: "Builder",
};

export const summaryOptions = [
  "Reasons *",
  "Challenges *",
  "Errors/Quality Identified *",
  "Output Goals for Next Week *",
  "Support and Resources Needed *",
];
